import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
@Component({
  selector: 'app-json-viewer-dialog',
  templateUrl: './json-viewer-dialog.component.html',
  styleUrls: ['./json-viewer-dialog.component.scss'],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    NgxJsonViewerModule
  ]
})
export class JsonViewerDialogComponent {
  jsonData: any;

  constructor(
    public dialogRef: MatDialogRef<JsonViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.jsonData = data;
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
